import 'mutation-observer';
import 'element-behaviors';

/**
 * AbstractComponent
 */
export class AbstractComponent {
  /**
   * element
   */
  element: Element;

  prefetch = null;

  /**
   * getElement
   * @return Element
   */
  getElement() {
    return this.element;
  }

  /**
   * getContent
   * @return Element
   */
  getContent() {
    return this.element.shadowRoot || this.element;
  }

  /**
   * @return Document
   */
  getDocument() {
    return this.element.ownerDocument;
  }

  /**
   * final implementation in Prefetchable decorator
   */
  getPrefetch() {
    console.error("component '" + this.element.tagName.toLowerCase() + "' element not decorated by @Prefetch()");
  }
}
